import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {TheCageGameAssets} from "./TheCageGameAssets";
import {TheCageGameData} from "./server/TheCageData";
import {TheCageGameMode} from "./server/TheCageGameMode";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {TheCage} from "./TheCage";
import {TheCageSound} from "./sound/TheCageSound";
import {RestoreUtils} from "./utils/RestoreUtils";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class TheCagePromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Dead Canary",
            hasActionSpin: true,
            graphics: {backgroundTextureName: TheCageGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: TheCageGameData, bet: number, prevResponse: TheCageGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: response.mode === TheCageGameMode.FREESPIN ? WINTYPE.MULTIPLIER : WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            TheCage.soundPlayer.playSound(TheCageSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            TheCage.soundPlayer.playSound(TheCageSound.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(data: TheCageGameData): void {
        RestoreUtils.resetToPlayBonusInGame(data);
    }

    private isBigWin(response: TheCageGameData): boolean {

        let win = (response.mode === GameMode.NORMAL || response.mode === TheCageGameMode.NORMAL_AVALANCHE) ? response.totalSpinWinnings : response.totalAvalancheRoundWinnings;
        if (response.mode == TheCageGameMode.NORMAL_AVALANCHE && response.nextMode == TheCageGameMode.NORMAL) {
            win = response.accumulatedRoundWin;
        }


        if (response.wasFeatureBuy) {
            const betPrice = this.getBetPrice(response)
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getBetPrice(response: TheCageGameData): number {
        const betLevel: string = TheCage.apiPlugin.freeBets.hasFreeBets() ? TheCage.apiPlugin.freeBets.getBet() : TheCage.apiPlugin.betLevel.getLevel();
        let price: number = response.playedBetValue || parseFloat(betLevel);
        if (response.wasFeatureBuy) {
            for (let index = 0; index < TheCage.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCage.model.initData.featureBuyTimesBetValue[index].name === TheCage.model.buyFeatureName) {
                    price *= TheCage.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private getSpinWin(response: TheCageGameData, bet: number, prevData: TheCageGameData): number {
        return response.totalAvalancheRoundWinnings;
    }

    private isFreeSpinTriggered(response: TheCageGameData): boolean {
        return (response.mode === TheCageGameMode.NORMAL || response.mode === TheCageGameMode.NORMAL_AVALANCHE) && response.nextMode === TheCageGameMode.FREESPIN;
    }

    private getFeatureName(response: TheCageGameData): string {
        if ((response.mode === TheCageGameMode.NORMAL || TheCageGameMode.NORMAL_AVALANCHE) && response.nextMode === TheCageGameMode.FREESPIN) {
            if (response.fsLevelEnterWith === 0) {
                return "BIG FATTY: TITLE FIGHT SPINS"
            } else if (response.fsLevelEnterWith === 1) {
                return "IRONJAW: TITLE FIGHT SPINS"
            } else if (response.fsLevelEnterWith === 2) {
                return "ONE GLOVE MAN: TITLE FIGHT SPINS"
            } else if (response.fsLevelEnterWith === 3) {
                return "THE CONSTRICTOR: TITLE FIGHT SPINS"
            } else {
                return "THE LITTLE DRAGON: TITLE FIGHT SPINS";
            }
        } else {
            if (response.fsLevel === 0) {
                return "BIG FATTY: TITLE FIGHT SPINS"
            } else if (response.fsLevel === 1) {
                return "IRONJAW: TITLE FIGHT SPINS"
            } else if (response.fsLevel === 2) {
                return "ONE GLOVE MAN: TITLE FIGHT SPINS"
            } else if (response.fsLevel === 3) {
                return "THE CONSTRICTOR: TITLE FIGHT SPINS"
            } else {
                return "THE LITTLE DRAGON: TITLE FIGHT SPINS";
            }
        }
    }

    private isRoundComplete(response: TheCageGameData): boolean {
        return ([TheCageGameMode.FREESPIN, TheCageGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: TheCageGameData): boolean {
        return ((response.nextMode === TheCageGameMode.NORMAL) && (response.mode === TheCageGameMode.FREESPIN));
    }


}